<script lang="ts">
    import type {AxiosInstance} from 'axios';

    import {dyData, modal} from 'general/store';
    import {TEMPLATE} from 'general/constants';

    import Description from 'general/components/description/Description.svelte';
    import Form from 'general/components/form/sms/Form.svelte';
    import Policy from 'general/components/policy/Policy.svelte';
    import ActionButton from 'general/components/actionButton/ActionButton.svelte';
    import Brands from 'desktop/components/brands/Brands.svelte';
    import SaleText from 'desktop/components/saleText/SaleText.svelte';
    import ScrollItem from 'general/components/scrollItem/ScrollItem.svelte';

    import s from './style.module.css';

    export let instance: AxiosInstance;
</script>

<ScrollItem>
    <div class={s.main} style="margin-top: {$dyData.side.sms?.marginTop || 0}">
        <div class={s.imageContainer}>
            <img class={s.image} src={$dyData.side.sms?.image} alt={$dyData.side.sms?.alt} />
            <SaleText side="sms" />
            <div class="brandsContainer">
                <Brands />
            </div>
        </div>

        <Description template={TEMPLATE.EXP_SQUARE} value={$dyData.description?.sms} />
        <Policy padding="12px" side="sms" template={TEMPLATE.EXP_SQUARE} />
        <Form {instance} label="Enter your phone number" template={TEMPLATE.EXP_SQUARE} />
        {#if $dyData.actionButton?.sms}
            <ActionButton
                handleClick={modal.close}
                marginTop="14px"
                marginBottom="20px"
                children="No thanks, remind me later"
                color="gray"
                template={TEMPLATE.SQUARE}
                {...$dyData.actionButton?.sms}
            />
        {/if}
    </div>
</ScrollItem>
